import { defineStore } from 'pinia'
import { removeLocalCache } from '@/utils/cache'

export const useTokenStore = defineStore(
  'userToken',
  () => {
    const refreshtoken = ref('')
    const token = ref('')
    const setRefreshtoken = (value) => {
      refreshtoken.value = value
    }
    const setToken = (value) => {
      token.value = value
    }

    const getRefreshtoken = computed(() => refreshtoken.value)
    const getToken = computed(() => token.value)

    const removeAll = () => {
      refreshtoken.value = ''
      token.value = ''
      removeLocalCache('refreshtoken')
      removeLocalCache('token')
    }

    return { setRefreshtoken, setToken, getRefreshtoken, getToken, removeAll, refreshtoken, token }
  },
  {
    persist: true,
  },
)
